const prefix = 'fasr';
const iconName = 'underline';
const width = 448;
const height = 512;
const aliases = [];
const unicode = 'f0cd';
const svgPathData = 'M16 32H40h96 24V80H136 112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312 288V32h24 96 24V80H408 384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40 16V32zM0 432H24 424h24v48H424 24 0V432z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
